/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfNavigationItemDto } from '../../models/platform-api-result-of-navigation-item-dto';
import { PlatformMoveMenuItem } from '../../models/platform-move-menu-item';

export interface PostNavigationitemsActionMovemenuitem$Params {
      body: PlatformMoveMenuItem
}

export function postNavigationitemsActionMovemenuitem(http: HttpClient, rootUrl: string, params: PostNavigationitemsActionMovemenuitem$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
  const rb = new RequestBuilder(rootUrl, postNavigationitemsActionMovemenuitem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfNavigationItemDto>;
    })
  );
}

postNavigationitemsActionMovemenuitem.PATH = '/api/navigationitems/action/movemenuitem';
